<template>
    
    <div>
        <!-- hide if length 0  -->
        <div id="pick_panel" v-if="any_selected" class="box"> 
            <div v-for="rev in selectedreviewables"
                 v-bind:key="rev.id"
            >
                <span>
                    <a @click="RemoveSelected(rev)" class="delete"></a>
                    {{ rev.name }}
                </span>
            </div>
            <button @click="ShowShareForm(selectedreviewables)" class="button is-primary is-large">share</button>
        </div>
    </div>

</template>

<script>
    import { eventBus } from '../main';
    import ShareForm from './ShareForm.vue'

    export default {
        data() {
            return {
                selectedreviewables : null,
                any_selected: false,
            }
        },
        methods: {
            ShowShareForm() {
                var modaldia = this.$buefy.modal.open({
                    parent: this,
                    component: ShareForm,
                    hasModalCard: true,
                    props: {'reviewables': this.selectedreviewables},
                })
            },
            RemoveSelected(reviewable) {
                eventBus.ToggleSelectedReviewable(reviewable)
            },
            GetSelectedReviewables() {
                this.selectedreviewables = eventBus.selected_reviewables

                if (eventBus.selected_reviewables.length > 0) {
                    this.any_selected = true
                }
                else {
                    this.any_selected = false
                }
            }
        },
        mounted() {
            // get selected on mount in case page has reloaded
            this.GetSelectedReviewables()
            
            //  listening for events when a reviewable is selected
            eventBus.$on('reviewable_selected', (selected_reviewables) => {
                this.GetSelectedReviewables()
            })
        },
    }

</script>

<style scoped>

    .box {
        position: fixed;
        bottom: 0;
        left: 0;
        margin: 1em;
        z-index: 1;
    }
</style>